// @ts-nocheck
import React from "react";

export default function ActiveFilterChips({ filters, onRemove }) {
  const chips = [];

  if (filters.distance) {
    chips.push({ key: "distance", label: `${filters.distance} miles` });
  }

  if (filters.dateRange && filters.dateRange !== "all") {
    if (filters.dateRange === "custom" && filters.customStart && filters.customEnd) {
      chips.push({
        key: "dateRange",
        label: `${filters.customStart} to ${filters.customEnd}`,
      });
    } else {
      chips.push({ key: "dateRange", label: filters.dateRange.replace("_", " ") });
    }
  }

  if (filters.month) {
    chips.push({
      key: "month",
      label: `Month ${filters.month}`,
      value: filters.month,
      type: "month",
    });
  }

  if (filters.year) {
    chips.push({
      key: "year",
      label: `Year ${filters.year}`,
      value: filters.year,
      type: "year",
    });
  }

  filters.games.forEach((game) => {
    chips.push({ key: `game-${game}`, label: game, value: game, type: "games" });
  });

  filters.eventTypes.forEach((eventType) => {
    chips.push({
      key: `eventType-${eventType}`,
      label: eventType.replace("_", " "),
      value: eventType,
      type: "eventTypes",
    });
  });

  if (chips.length === 0) {
    return null;
  }

  return (
    <div className="active-filters">
      {chips.map((chip) => (
        <button
          key={chip.key}
          type="button"
          className="active-chip"
          onClick={() => onRemove(chip)}
        >
          {chip.label}
          <span className="chip-remove">x</span>
        </button>
      ))}
    </div>
  );
}
